module.exports = __webpack_public_path__ + "static/media/ic_searchtype_rocky.773c73a9.svg";